// extracted by mini-css-extract-plugin
export default {"risk-color-low":"RiskMessage_risk-color-low__zRldr","risk-color-mid":"RiskMessage_risk-color-mid__jc4iO","risk-color-high":"RiskMessage_risk-color-high__U+uc1"};